import axios from 'axios';
import { logResponse, prepareRequest, rejectAsApiError } from './services/interceptors';

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

axios.interceptors.request.use(prepareRequest);

axios.interceptors.response.use(logResponse, rejectAsApiError);
